/** Device preview — renders the live app inside a phone/tablet-width iframe so
 * mobile layout can be checked from the desktop. The iframe is same-origin, so it
 * shares the signed-in session and data, and its narrow width triggers the mobile
 * CSS breakpoints. This requires the server to allow same-origin framing
 * (X-Frame-Options: SAMEORIGIN in public/_headers) — with DENY the frame is
 * blocked and shows blank. A size picker swaps the frame; it scales down if it's
 * taller than the viewport. */
import { useState } from "react";
import { Icon } from "./icons";

const SIZES: { label: string; w: number; h: number }[] = [
  { label: "iPhone · 390", w: 390, h: 844 },
  { label: "Max · 430", w: 430, h: 932 },
  { label: "iPad · 768", w: 768, h: 1024 },
];

export function DevicePreview({ onClose }: { onClose: () => void }) {
  const [idx, setIdx] = useState(0);
  const size = SIZES[idx] ?? SIZES[0]!;
  const src =
    typeof window !== "undefined" ? window.location.origin + window.location.pathname + window.location.search : "/";

  // Scale the frame down to fit the viewport height (leave room for the chrome).
  const avail = typeof window !== "undefined" ? Math.max(window.innerHeight - 150, 420) : 700;
  const scale = Math.min(1, avail / (size.h + 24));

  return (
    <div className="modalwrap dpwrap" onClick={onClose}>
      <div className="dpinner" onClick={(e) => e.stopPropagation()}>
        <div className="dpbar">
          <span className="dptitle"><Icon name="smartphone" size={15} /> Mobile preview</span>
          <div className="dpsizes">
            {SIZES.map((s, i) => (
              <button key={s.label} className={"dpsize" + (i === idx ? " on" : "")} onClick={() => setIdx(i)}>{s.label}</button>
            ))}
          </div>
          <button className="iconbtn light" title="Close" onClick={onClose}><Icon name="x" size={18} /></button>
        </div>
        <div className="dpstage">
          <div className="dpframe" style={{ transform: `scale(${scale})`, transformOrigin: "top center" }}>
            <div className="dpbezel" style={{ width: size.w, height: size.h }}>
              <iframe className="dpiframe" src={src} title="Mobile preview" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
